<template>
  <v-btn-toggle
    v-on="$listeners"
    multiple
    :value="value"
  >
    <v-btn
      v-for="item in items"
      small
      outlined
      :key="item.value"
      :value="item.value"
    >
      <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
      <template>{{ item.label }}</template>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: 'ToggleButtons',
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      required: true
    },
  },
}
</script>

<style lang="scss" scoped>
.v-item-group {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  .v-btn {
    min-width: unset!important;
    height: 32px;
    padding: 0 6px;
    flex: 1;
    border-width: 1px!important;
    border-radius: 6px!important;
    color: var(--v-primary-base);
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0px;
    opacity: 1;
    text-transform: capitalize;
  }
}

::v-deep {
  .v-btn__content {
    gap: 4px;
  }

  .v-btn--active {
    .v-btn__content {
      color: white;
    }

    path {
      fill: white;
    }

    &::before {
      opacity: 1;
      top: -1px;
      left: -1px;
      right: -1px;
      bottom: -1px;
    }
  }
}
</style>
